import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useLibraryStore = defineStore('library', {
    state() {
        return {
            books: [],
            authors: {},
            categories: []
        }
    },
    actions: {
        async getBooks(
            start,
            end,
            searchString = '',
            categoriesId = [],
            authorsId = [],
            isDesc = true
        ) {
            const data = {
                start,
                end,
                search_string: searchString,
                categories_id: categoriesId,
                authors_id: authorsId,
                is_desc: isDesc
            }

            this.books = await helper.api('GET', '/library', data)
        },

        async getCategories() {
            this.categories = await helper.api('GET', '/library/categories', {})
        },

        async getAuthors(searchString = '') {
            const data = {
                search_string: searchString
            }

            this.authors = await helper.api('GET', '/library/authors', data)
        }
    },
    getters: {
        formatFilters(state) {
            return (isAuthors) => {
                const result = []
                const data = isAuthors ? state.authors : state.categories

                if (isAuthors) {
                    for (const author of data) {
                        result.push({
                            id: author.id,
                            title: `${author.surname} ${author.name} ${author.patronymic}`
                        })
                    }
                } else {
                    for (const category of data) {
                        result.push({
                            id: category.id,
                            title: category.name
                        })
                    }
                }

                return result
            }
        }
    }
})
